if (window.location.pathname.includes('/account')) {
  const targetContainer = document.querySelector('.account-user');

  const interval = setInterval(() => {
    const button = document.querySelector('.sky-pilot-customer-account-digital-items-link a');

    if (button && targetContainer) {
      clearInterval(interval); 
      document.documentElement.lang === 'de'
        ? button.textContent = 'Meine Backkurse'
        : button.textContent = 'My baking courses';

      button.style.background = 'transparent';
      button.style.border = '1px solid black';
      button.style.color = 'black';
      button.style.padding = '10px 15px';
      button.style.display = 'block';
      button.style.marginTop = '0px';
      button.style.width = 'fit-content';

      targetContainer.appendChild(button);
    }
  }, 300); 
}
